export function encodeObject(obj) {
  return encodeURIComponent(JSON.stringify(obj));
}
